import Header from "components/Common/Header/Header";
import ChallengeDashboardBody from "components/ChallengeComponents/Dashboard/DashboardBody/ChallengeDashboardBody";

import React, { useEffect } from "react";

const ChallengeDashboard = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Challenges";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="challenges" />
      {/* ---- dashboard body ---- */}
      <ChallengeDashboardBody />
    </main>
  );
};

export default ChallengeDashboard;
